<template>
	<layout-admin>
		<div class="py-6 px-4 sm:px-6 lg:px-8">
			<ui-alert
				v-if="success"
				type="success"
				:message="success == true ? 'Your inputs have been saved!' : success"
			/>
			<ui-alert v-if="error" type="error" :message="error" />

			<div class="pb-8 px-6 fixed bottom-0 flex right-0 z-10">
				<ui-button
					class="ml-auto text-lg shadow-xl"
					label="Save"
					v-on:click="submitForm()"
					:disabled="submitButtonDisabled"
				/>
			</div>

			<h1 class="text-3xl font-semibold text-gray-900 mb-4">
				{{ __("Marktkompass Beitrag erstellen") }}
			</h1>

			<div class="pb-8 px-6 fixed top-24 flex right-0 z-10">
				<ui-button
					type="secondary"
					v-on:click="$inertia.visit(backUrl)"
					class="flex items-center"
				>
					{{ __("Back") }}
				</ui-button>
			</div>

			<div class="grid grid-cols-8 gap-y-4 gap-x-6">
				<ui-input-group
					class="col-span-4"
					v-model="form.title"
					label="Title"
					:form="form"
					field="title"
					:required="true"
				/>

				<ui-input-group
					class="col-span-4"
					v-model="form.market_news_items_order"
					label="Order"
					:form="form"
					field="market_news_items_order"
					:required="true"
				/>

				<ui-textarea-group
					class="col-span-4"
					v-model="form.text"
					field="text"
					label="Text"
					:form="form"
					:required="false"
					:rows="10"
					:maxWProse="false"
				/>

				<div class="col-span-4">
					<label class="block font-medium">{{ __("Title Image") }}</label>
					<input
						type="file"
						@input="form.titleImage = $event.target.files[0]"
					/>
					<ui-validation-message :form="form" field="titleImage" />
					<ui-input-group
						class="mt-3"
						v-model="form.title_image_url"
						label="Image URL"
						:form="form"
						field="title_image_url"
						:required="false"
					/>
				</div>
			</div>
		</div>
	</layout-admin>
</template>

<script>
import Vue from "vue";
let options = require("../../cropOptions");
export default {
	props: {
		newsItem: {
			type: Object,
			required: true,
		},
		market_news_id: {
			type: Number,
			required: true,
		},
		success: {
			default: false,
		},
		error: {
			type: String,
			required: false,
		},
	},
	data() {
		this.newsItem.titleImage = null;
		return {
			form: Vue.observable(this.$inertia.form(this.newsItem)),
			submitButtonDisabled: false,
		};
	},
	computed: {
		backUrl() {
			return window.baseUrl + "/admin/market-news/" + this.market_news_id;
		},
	},
	created() {
		//console.log(this.initialData);
	},
	methods: {
		async submitForm() {
			let endpoint = this.$page.url,
				method = "post",
				that = this;

			this.submitButtonDisabled = true;
			this.form.submit(method, endpoint, {
				preserveState: true,
				onSuccess(p) {
					console.log("SUCCESS SUBMISSION, got: ", p);
				},
				onFinish(e) {
					that.submitButtonDisabled = false;
					console.log("submit FINISH", method, endpoint, "got:", e);
				},
			});
		},
	},
};
</script>
